import { render, staticRenderFns } from "./OtherStatus.vue?vue&type=template&id=7e216947&scoped=true"
import script from "./OtherStatus.vue?vue&type=script&lang=js"
export * from "./OtherStatus.vue?vue&type=script&lang=js"
import style0 from "./OtherStatus.vue?vue&type=style&index=0&id=7e216947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e216947",
  null
  
)

export default component.exports